import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Section from 'modules/contracts/components/ContractDetails/Section'
import useCanSeeApprovalRequest from 'modules/contracts/hooks/useCanSeeApprovalRequest'
import type ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

interface Props {
  employee: Employee
  contractVersionRequest: ContractVersionRequest
}

const AboutTheRequest = ({ employee, contractVersionRequest }: Props) => {
  const { navigation } = useNavigation()
  const canPromote = policyAuthorizations.for('contracts.promote', employee)
  const canSeeApprovalRequest = useCanSeeApprovalRequest({
    contractVersionRequest,
    canPromote,
  })

  if (!canSeeApprovalRequest) return null
  const authorName = contractVersionRequest.authorName

  return (
    <Section icon="inbox" title={i18n.t('contract_versions.about_request.title')}>
      <Box flexDirection="row" width="full" justifyContent="spaceBetween" alignItems="center">
        <Text.Normal>
          {i18n.t('contract_versions.about_request.description', {
            authorName: authorName,
          })}
        </Text.Normal>
        <Button.Router
          type="secondary"
          to={navigation.employees.id.contractVersions.approval_request.fullPath({
            id: employee.id.toString(),
            contractVersionId: contractVersionRequest.id.toString(),
          })}
        >
          {i18n.t('contract_versions.about_request.see_details')}
        </Button.Router>
      </Box>
    </Section>
  )
}

export default observer(AboutTheRequest)
